"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = require("react-helmet");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _AppContext = require("./context/AppContext");
var _SocialMediaTrackers = _interopRequireDefault(require("./SocialMediaTrackers"));
var _withRouter = require("../HOCs/withRouter");
var _utils = require("../utils");
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/App.css") : void 0;
var _userProfileModule = require("../userProfile/userProfileModule");
var _utilsModule = require("../utils/utilsModule");
var _listingsModule = require("../listings/listingsModule");
var _listingModule = require("../listing/listingModule");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var urlToLang = function urlToLang(url) {
  return (0, _utils.mapCountryToPublicLang)((0, _utils.getCountryCode)(url));
};
var TEXT_JAVACRIPT = 'text/javascript';
var App = /*#__PURE__*/function (_Component) {
  function App(props) {
    var _this;
    _classCallCheck(this, App);
    _this = _callSuper(this, App, [props]);
    props.isAppCenterEnabledCheck();
    props.setIsPublic((0, _utils.isPublic)(props.location.pathname));
    _this.scripts = [];
    _this.links = [];

    // TODO: figure out why the details page won't update canonical, then re-enable
    if (props.meta.isPublic) {
      if (props.adobeAnalyticsAllowed) {
        _this.scripts.push({
          src: '//scripts.demandbase.com/adobeanalytics/4d7mpJHG.min.js',
          type: TEXT_JAVACRIPT
        });
      }
      _this.scripts.push({
        src: '//code.jquery.com/jquery-3.7.1.min.js',
        type: TEXT_JAVACRIPT
      });
      if (props.adobeAnalyticsAllowed) {
        _this.scripts.push({
          src: '//api.demandbase.com/api/v2/ip.json?key=a7aff587da16f950808755d170a3ea666414468c&amp;callback=Dmdbase_CDC.callback',
          type: TEXT_JAVACRIPT
        });
        _this.scripts.push({
          src: '//static.concursolutions.com/nui/appcenter/static/omniture.bundle.f4e88b342e6ff25c6df3.js',
          type: TEXT_JAVACRIPT
        });
      }
      if (props.meta.originalhost) {
        _this.links.push({
          rel: 'canonical',
          href: "".concat((0, _utils.getCanonicalLink)((0, _utils.sanitizeOriginalHost)(props.meta.originalhost), props.location.pathname))
        });
      }
      _this.links.push({
        rel: 'shortcut icon',
        href: '//www.concur.com/sites/all/themes/concur7/favicon.ico',
        type: 'image/png'
      });
      (0, _utils.getHreflangLinks)(_this.links, props.location.pathname);
    }
    return _this;
  }
  _inherits(App, _Component);
  return _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var meta = this.props.meta;
      if ((0, _utils.canUseDOM)() && meta.isPublic && !meta.inDevelopmentMode) {
        if (window.utag_data) {
          window.site_regional = urlToLang(this.props.meta.originalhost);
        }
      }
      if (!meta.inDevelopmentMode) {
        this.loadTrustArcScript();
      }
      this.props.fetchListingsIfNeeded();
      this.props.fetchLocalizedRegions();
      this.props.fetchLocalizedCountries();
    }
  }, {
    key: "loadTrustArcScript",
    value: function loadTrustArcScript() {
      var script = document.createElement('script');
      script.src = '//consent.trustarc.com/notice?domain=concur.com&c=teconsent&js=nj&noticeType=bb&text=true';
      script.async = true;
      window.onload = function () {
        var footerElement = document.getElementById('teconsent');
        footerElement.appendChild(script);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var title = 'SAP Concur App Center';
      var _this$props = this.props,
        meta = _this$props.meta,
        adobeAnalyticsAllowed = _this$props.adobeAnalyticsAllowed;
      var context = {
        userProfile: this.props.userProfile,
        isPublic: meta.isPublic,
        getTitle: function getTitle(newTitle) {
          if (newTitle !== _utils.HOME) {
            return "".concat(newTitle, " - ").concat(title);
          }
          return title;
        }
      };
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        id: "app",
        style: meta.isPublic ? {
          backgroundColor: '#efefef'
        } : null
      }, meta.isPublic ? {
        role: 'main'
      } : {}), /*#__PURE__*/_react.default.createElement(_AppContext.AppContext.Provider, {
        value: context
      }, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, {
        htmlAttributes: {
          lang: (0, _utils.getNuiLanguage)(this.props.meta.originalhost)
        },
        title: title,
        meta: [{
          'char-set': 'utf-8'
        }, {
          name: 'application-name',
          content: this.props.formatter.formattedMessage({
            id: 'AppCenterHeader'
          })
        }, {
          name: 'description',
          content: this.props.formatter.formattedMessage({
            id: 'MetaDescription'
          })
        }, {
          name: 'keywords',
          content: 'Concur App Center, App Center'
        }, {
          name: 'viewport',
          content: 'width=device-width,initial-scale=1'
        }],
        script: this.scripts,
        link: this.links
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "route-content ".concat((0, _utils.isPublic)(this.props.location.pathname) ? 'public-content container' : ''),
        style: {
          fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif'
        }
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Outlet, null))), meta.isPublic && adobeAnalyticsAllowed && /*#__PURE__*/_react.default.createElement(_SocialMediaTrackers.default, null));
    }
  }]);
}(_react.Component); // We don't own location, formatter, or userProfile so we shouldn't define the shape.
// Ideally the react-router and nui-intl packages would expose the shape and we could consume it.
App.propTypes = {
  isAppCenterEnabledCheck: _propTypes.default.func.isRequired,
  setIsPublic: _propTypes.default.func.isRequired,
  meta: _propTypes.default.shape({
    originalhost: _propTypes.default.string,
    isPublic: _propTypes.default.bool
  }).isRequired,
  adobeAnalyticsAllowed: _propTypes.default.bool.isRequired,
  userProfile: _propTypes.default.object,
  location: _propTypes.default.object,
  formatter: _propTypes.default.object
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    userProfile: state.userProfile,
    meta: state.meta,
    adobeAnalyticsAllowed: state.userPrefs.adobeAnalyticsAllowed
  };
};
var mapDispatchToProps = {
  isAppCenterEnabledCheck: _userProfileModule.isAppCenterEnabledCheck,
  setIsPublic: _utilsModule.setIsPublic,
  fetchListingsIfNeeded: _listingsModule.fetchListingsIfNeeded,
  fetchLocalizedRegions: _listingModule.fetchLocalizedRegions,
  fetchLocalizedCountries: _listingModule.fetchLocalizedCountries
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _nuiIntlRuntime.withFormatter)((0, _withRouter.withRouter)(App)));